import { get } from "lodash";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import DisTable from "src/components/TableV2/Table";
import useAutosave from "src/hooks/useAutosave";
import { useLoading } from "src/hooks/useLoading";
import { IApplicationInsured } from "src/store/models/application.model";
import { IRootState } from "src/store/reducers";
import {
  fetchAppInsuredDetails,
  fetchAppInsuredOptions,
  fetchAppInsuredsList,
  saveAppInsureds,
} from "src/store/reducers/applicationInsureds";
import { formatDate } from "src/views/CampaignDetail/utils";
import * as S from "../../../../constants/StringConstants";
import { PageContainerButtons } from "../../PageContainer";
import { TabProps } from "../../pages";
import { AddInsuredModal } from "./AddInsuredModal";

const columns = [
  { key: "name", title: S.APP_INSUREDS_COL_NAME, style: { minWidth: "5rem" } },
  {
    key: "dateOfBirth",
    title: S.APP_INSUREDS_COL_DOB,
    style: { minWidth: "5rem" },
    render: (item: IApplicationInsured) => formatDate(item.dateOfBirth),
  },
  { key: "ssn", title: S.APP_INSUREDS_COL_SSN, style: { minWidth: "5rem" } },
  { key: "externalNumber", title: S.APP_INSUREDS_COL_NUMBER, style: { minWidth: "5rem" } },
];

export const AppAdditionalInsureds = (props: TabProps) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const dispatch = useDispatch();
  const { id: applicationId } = useParams<{ id: string }>();
  const { setIsLoading } = useLoading();

  const { appInsuredDetails } = useSelector((state: IRootState) => ({
    appInsuredDetails: state.applicationInsureds.insuredDetails,
  }));

  const AutoSave = useAutosave(props, () => {});

  const handleRowClick = async (insured: IApplicationInsured) => {
    try {
      setIsLoading(true);
      await dispatch(fetchAppInsuredDetails(insured.id));
      setModalOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveInsured = async (values: Partial<IApplicationInsured>) => {
    const payload = {
      ...values,
      applicationID: Number(applicationId),
    };

    try {
      await dispatch(saveAppInsureds(applicationId, payload));
    } catch (error) {
    } finally {
      setModalOpen(false);
      setRefreshKey(prev => prev + 1); // updates table
    }
  };

  const handleAddInsuredClick = async () => {
    try {
      setIsLoading(true);
      await dispatch(fetchAppInsuredOptions());
      setModalOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <DisTable<IApplicationInsured>
        key={refreshKey}
        columns={columns}
        initialState={{}}
        onRowClick={handleRowClick}
        onUpdate={async () => {
          const result: any = await dispatch(fetchAppInsuredsList(applicationId));

          return {
            total: get(result, "value.data.totalRows") as number,
            data: get(result, "value.data.items") as IApplicationInsured[],
          };
        }}></DisTable>

      <AddInsuredModal
        open={modalOpen}
        handleConfirm={handleSaveInsured}
        handleReject={() => {
          setModalOpen(false);
        }}
        insuredDetails={appInsuredDetails}
      />

      <PageContainerButtons>
        <button className="button-v2 button-v2__secondary" type="button" onClick={handleAddInsuredClick}>
          {S.APP_INSUREDS_ADD_INSURED}
        </button>
      </PageContainerButtons>
      <AutoSave />
    </>
  );
};
